export default __webpack_public_path__ + "static/media/NITRO.a04a3d6b.png";